import React from "react";
import { useShindan } from "../../hooks/use-shindan";
import Question from "../question";
import Progress from "../progress";
import ErrorMessage from "../error-message";
import Result from "../result";
import { AnimatePresence } from "framer-motion";
import Loader from "../loader";
import Title from "../title";
import { colors } from "../../config/color";

type ShindanProps = ReturnType<typeof useShindan>;

export const Shindan: React.FC<ShindanProps> = ({
  error,
  isLoading,
  title,
  subTitle,
  question,
  currentIndex,
  progressCount,
  totalCount,
  result,
  type,
  handleNext,
}) => {
  if (error) {
    return (
      <div className="shindan-app__content">
        <ErrorMessage>{error.message}</ErrorMessage>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="shindan-app__content">
        <div className="center-loader">
          <Loader color={type && colors[type]} />
        </div>
      </div>
    );
  }

  return (
    <div className="shindan-app__content">
      <Title title={title} subTitle={subTitle} />

      <div className="shindan-app__body">
        {result ? (
          <Result to={result} type={type} />
        ) : (
          <AnimatePresence exitBeforeEnter>
            <Question
              key={`${question?.category}${question?.number}`}
              question={question}
              handleNext={handleNext}
            />
          </AnimatePresence>
        )}
      </div>

      <Progress count={progressCount} percent={currentIndex / totalCount} />
    </div>
  );
};
